import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  optionText: {
    color: theme.palette.text.primary,
  },
}))

export default useStyles
